export const PREFERRED_API_REGION_KEY = "preferredApiRegion";
export const MENU_ACTIONS_HIDDEN_WHEN_OUS = ["usa_approvals", "rebateProgram"];
